<script>
  import { onMount } from "svelte";
  import FABModal from "../../helper/modal";
  import Link from "./Link.svelte";
  export let fab_item = {};
  export let classNames = "";

  // Transform variables.
  classNames += ` fab-link-modal`;

  // Initiate jQuery functions.
  onMount(() => {
    jQuery(document).ready(function () {
      FABModal.event_close_link();
      FABModal.register_on_click_event();
    });
  });

  // Handle click.
  function handle_click(e) {
    // if modal is auth_logout, then show the logout button
    if (fab_item.type === "auth_logout") {
      setTimeout(() => {
        const { link } = e.detail.fab_item;
        window.location.href = link;
      }, 3000);
    }
  }
</script>

<Link {fab_item} {classNames} on:click={handle_click} />
